import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

export default function FormSection({ title, description, headerAside, children }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  return (
    <Paper
      variant="outlined"
      sx={{
        p: { xs: 1.5, sm: 2 },
        mb: 2,
        borderRadius: 2,
        bgcolor: isDark ? 'background.paper' : alpha(theme.palette.background.paper, 0.9),
        borderColor: alpha(theme.palette.primary.main, isDark ? 0.28 : 0.12),
      }}
    >
      {title || headerAside ? (
        <Box
          display="flex"
          alignItems={{ xs: 'stretch', sm: 'center' }}
          justifyContent="space-between"
          gap={1.5}
          flexDirection={{ xs: 'column', sm: 'row' }}
          mb={description || children ? 1 : 0}
        >
          {title ? (
            <Typography variant="subtitle2" fontWeight={700} sx={{ flexShrink: 0 }}>
              {title}
            </Typography>
          ) : null}
          {headerAside ? (
            <Box sx={{ width: { xs: '100%', sm: 280 }, flexShrink: 0 }}>
              {headerAside}
            </Box>
          ) : null}
        </Box>
      ) : null}
      {description ? (
        <Typography variant="caption" color="text.secondary" display="block" mb={1.5}>
          {description}
        </Typography>
      ) : null}
      {children}
    </Paper>
  );
}
